import BasketSubscriber from "../components/BasketSubscriberReport/BasketSubscriber";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const BasketSubscriberReport = () => {

    const email1 = useSelector((state) => state.user.email);
    const navigate = useNavigate();
    useEffect(() => {
        if (email1 === null || email1 === "") {
            navigate("/")
        }
    }, [email1, navigate])




    return (
        <div className="my-12 px-2 md:px-1 max-w-screen-2xl mx-auto py-5">
            <BasketSubscriber />
        </div>
    )
}

export default BasketSubscriberReport

